import React, { useEffect } from 'react'

const TOSLicense = () => {
  useEffect(() => {
    document.title = 'Terms of Software License and Service for Flux App'
  }, [])

  return (
    <div style={container}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8, textAlign: 'center' }}>
        Terms of Software License and Service for Flux App
      </h1>
      <p style={{ color: '#888', marginBottom: 32, textAlign: 'left' }}>Last updated: </p>

      <p>Thank you for using Flux App.</p>
      <p>
        These Terms of Services ("Terms") shall govern your use and access of Flux App provided by Hangzhou Furui Technology Co., Ltd.
        and/or their affiliates ("Flux", "we", "our", or "us").
      </p>
      <p>
        Flux Service may include (1) software applications that can be downloaded to a mobile device ("Flux App"), and (2) any services
        available on Flux App. For certain features or services of Flux App, additional terms of requirements may apply. In case of any
        conflict between such additional terms and these Terms, the additional terms shall prevail for the aforementioned certain features
        or services.
      </p>
      <p>
        We may modify these Terms at any time. You can determine when these Terms were last revised by referring to the date it was "Last
        Updated" above.
      </p>

      <h2 style={sectionTitle}>1. Electronic Contracting and Messaging</h2>
      <p>
        By using Flux Service under Flux App, you agree to accept and be bound by these Terms and our Privacy Policy. You agree that when
        you use your login credentials or click on any "I Agree" button when applying for or using Flux Service, you affirmatively consent
        to conduct business electronically with Flux, and such credentials and processes have the same force and effect with your written
        signature. In addition, you agree and consent to Flux sending you disclosures, messages, notices, and other communications, to your
        designated mobile phone and email account, in order to facilitate your timely access to information about our Services.
      </p>

      <h2 style={sectionTitle}>2. Eligibility; Children</h2>
      <p>
        You are prohibited from using Flux Service unless you are 18 years of age or older, or above the age of equivalent minimum age in
        the relevant jurisdiction. Please check your local law for the age of digital consent. You may not use Flux Service where prohibited
        by applicable law. If you are not 18 years of age or older, or under equivalent minimum age in the relevant jurisdiction, you should
        immediately exit this App and cease using any Flux services. Please contact us if you believe your child has provided us with
        personal information in connection with the Flux Service.
      </p>

      <h2 style={sectionTitle}>3. No Life-Safety or Critical Uses of Flux Service</h2>
      <p>
        You acknowledge and agree that Flux Service are not certified for emergency response. We make no warranty or representation that use
        of Flux Service with any third-party product or service will affect or increase any level of safety or security. Flux Service do not
        incorporate third-party monitored emergency notification system -- We will not dispatch emergency authorities to your home in the
        event of an emergency. All life threatening and emergency events should be directed to appropriate response services.
      </p>

      <h2 style={sectionTitle}>4. AI Disclaimer</h2>
      <p>
        Flux service utilizes AI technology to understand your intentions based on the information you provide ("Your Input") and the methods
        you choose, offering AI-generated fortune-telling predictions (the "Outputs"). Please note that:
      </p>
      <p>
        Due to the nature of AI technology, Flux cannot fully guarantee the accuracy, completeness, or functionality of the Outputs, which
        may contain omissions, errors, or technical and ethical risks. Flux service is not intended for professional fields such as medical
        or legal advice. All the Outputs do not represent Flux's views or commitments and should not be considered as advice or promises.
      </p>
      <p>
        You should be fully aware of these limitations. Except as required by applicable laws, Flux disclaims all liability related. You are
        responsible for evaluating and using this service and the Outputs at your own risk.
      </p>

      <h2 style={sectionTitle}>5. Account</h2>
      <p>To use Flux Service, you are required to create an Account; if applicable, you may login in Flux App through a third-party account.</p>

      <h3 style={subTitle}>Device ID account</h3>
      <p>
        When you install and use Flux App on your mobile device, your Flux service account will be automatically generated and uniquely
        linked to your device ID. You can directly access this App and use the services on the same device without needing to log in with an
        account. Where applicable, you may also register a Flux account manually or choose to associate your existing device ID account with
        your registered account, allowing you to log in and use the services with your account credentials.
      </p>

      <h3 style={subTitle}>Creating an Account</h3>
      <p>
        You represent and warrant that: (i) all required registration information you submit is truthful, accurate and complete; and (ii) you
        will maintain the accuracy, security, and confidentiality of such information and your password; and (iii) your use of the Account
        does not violate any applicable law or regulation. You have no right to transfer your Account to any other individuals in any manner.
        We are not liable for any loss or damages arising from your failure to maintain the confidentiality of your Account. You agree to
        notify us immediately of any unauthorized access to or use of your Account or any breach of security. You may be held liable for
        losses incurred by us or any other Flux users due to someone else using your Account as a result of your failing to keep your Account
        information secure and confidential.
      </p>
      <p>
        You may not use anyone else's Account at any time without the express permission and consent of the holder of that Account. We cannot
        and will not be liable for any loss or damage arising from your failure to comply with these obligations.
      </p>

      <h3 style={subTitle}>Closing your Account</h3>
      <p>
        You may close your Account at any time by using "Closing Your Account" functionality, or by writing an email to{' '}
        <a href="mailto:appworks.ai@gmail.com" style={linkStyle}>appworks.ai@gmail.com</a>. The Account is necessary to use Flux Service
        under Flux App. Before closing your Account, please ensure that you will not use Flux Service, and that you have closed the orders
        for certain features or services in your Account (if any). Please also keep in mind that you will not be able to reactivate your
        Account or retrieve any of the content or information you previously added to your Account. If you ever wanted to use such Flux
        Service again, you would need to create a new Account.
      </p>

      <h3 style={subTitle}>Login in through a third-party account</h3>
      <p>
        Before doing this, please ensure that you have full right for the third-party account you use, and you are willing to access to and
        manage the Flux Service through it. Furtherly, you understand and agree that, Flux may collect your public information with that
        third-party, only for generating your unique login license.
      </p>

      <h2 style={sectionTitle}>6. System and Equipment Requirements</h2>
      <p>
        You must have the necessary device, software, and Internet access needed to register and use Flux Service. Flux Service will not be
        accessible without: (i) a mobile device with Android OS, Apple iOS or other applicable operation system; (ii) an Account; (iii)
        always-on broadband Internet access; and (iv) other system elements that may be specified by us in connection with specific feature.
      </p>

      <h2 style={sectionTitle}>7. License</h2>
      <p>
        Subject to your compliance with these Terms, we grant you a revocable, limited, non-exclusive, non-transferable, non-sub-licensable
        license to install and use (a) Flux App, and (b) the individual services in this App, in each case solely in connection with your
        personal, non-commercial use of the Flux Service. You may only use the Flux App on devices that you own, lease, or otherwise control.
        No other licenses or rights are granted to you by implication or otherwise under any intellectual property rights owned or controlled
        by us or our licensors.
      </p>

      <h2 style={sectionTitle}>8. License Restrictions</h2>
      <p>
        Unless as expressly permitted in these Terms, you agree not to, and you will not permit others to, (i) license, sublicense, assign,
        convey or transfer, the rights and licenses granted hereunder; (ii) publish, display, disclose, sell, rent, lease, store, loan,
        distribute, transmit, publicly display or perform, co-brand, frame, host, outsource, or otherwise commercially exploit Flux Service,
        including the Flux App and the individual services (collectively, the "Software"), (iii) copy or reproduce Flux Service or Software
        or any part thereof, in any form; (iv) remove or alter any trademark, logo, copyright or other proprietary notices, legends, symbols
        or labels in the Software or Flux Service; (v) use the Software and Flux Service in any fashion that may infringe any patent,
        copyright, trademark, trade secret, or any other intellectual property or proprietary right of Flux, its third-party providers, or
        any other third-party; (vi) modify, translate, adapt, disassemble, reverse engineer decompile, reverse compile, or create
        compilations or derivative works of, the Software, Flux Service, or any part thereof (except to the extent applicable laws
        specifically prohibit such restriction), or (vii) use the Software or Flux Service for any service bureau, time-sharing, resale, or
        similar purposes.
      </p>
      <p>We reserve all rights and licenses in and to the Software not expressly granted to you under these Terms.</p>

      <h2 style={sectionTitle}>9. Open Source</h2>
      <p>
        Certain items of software included with the App are subject to "open source" or "free software" licenses ("Open Source Software").
        Some of the Open Source Software is owned by third parties. Each item of Open Source Software is licensed under the terms of the end
        user license that accompanies such Open Source Software. Nothing in these Terms limits your rights under, or grants you rights that
        supersede, the terms and conditions of any applicable end user license for the Open Source Software. If required by any license for
        particular Open Source Software, we make such Open Source Software, and our modifications to that Open Source Software, available by
        written request to us via our contact information. By downloading/requesting the source code to any of the Open Source Software
        ("Source Code"), you agree to the following:
      </p>
      <p style={notice}>
        WE PROVIDE THE SOURCE CODE TO YOU ON AN "AS IS" BASIS WITHOUT REPRESENTATIONS OR WARRANTIES OF ANY KIND. YOU EXPRESSLY AGREE THAT
        YOUR USE OF THE SOURCE CODE IS AT YOUR SOLE RISK. TO THE FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, FLUX AND ITS AFFILIATES
        DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE. FLUX AND ITS AFFILIATES WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE SOURCE CODE,
        INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES.
      </p>

      <h2 style={sectionTitle}>10. Access to Flux Service</h2>
      <p>
        You may access and use Flux Service solely to subscribe to Flux Service, manage your Account and preferences, and maintain your
        registration data, provided that Account management is available on Flux App.
      </p>
      <p>When using Flux Service, you shall not:</p>
      <ul style={listStyle}>
        <li>disrupt, interfere with, violate the security of, or attempt to gain unauthorized access to, Flux Service or any computer network owned by us or any other user of Flux Service;</li>
        <li>circumvent any technological measure implemented by us or any of our suppliers or any other third party (including another user of Flux Service) to protect Flux Service;</li>
        <li>upload, transmit, distribute, or run any computer virus, worm, Trojan horse, or any computer code that could damage or alter Flux Service or a computer, portable device, computer network, communication network, data, or any other system, device or property owned by us or any other user of Flux Service;</li>
        <li>run Maillist, Listserv, or any form of auto-responder or "spam" on Flux Service;</li>
        <li>attempt, in any manner, to obtain the password, account, credentials, or other security information from any other user;</li>
        <li>jeopardize the security of your Account or anyone else's account;</li>
        <li>impersonate any other user, person, or entity;</li>
        <li>provide referral information for someone else without first obtaining consent from the person being referred and notifying them that they may receive communication from us; or</li>
        <li>violate any applicable federal, state, local, or international law or regulation.</li>
      </ul>
      <p>These Terms shall apply to any future update, release, or other change to Flux Service.</p>

      <h2 style={sectionTitle}>11. Content</h2>
      <p>
        You may elect to display, share, email, or otherwise make available (collectively, "Submit") text, graphics, photographs, video,
        images, audio, and other works of authorship through Flux Service, e.g. Your Input and the Output you received, including for storage
        or sharing with third parties online ("Your Content"). When you post Your Content in third party social networking sites via Flux
        Service, such content will be accessible and viewed by others. You are solely responsible for Your Content submitted through Flux
        Service, and we will not be liable for any errors or omissions in Your Content.
      </p>
      <p>
        We may also make available on Flux Service text, graphics, photographs, video, images, illustrations, audio, music, commentary, and
        other works of authorship we own or from other users of Flux Service ("Our Content"). Our Content, along with Flux Service and its
        underlying technology, are protected by copyright, trademark, patent, Intellectual Property, and other laws of relevant jurisdiction
        and other countries. You may access and view Our Content solely for personal use and consumption, and are prohibited from copying,
        selling, renting, distributing, publicly performing, marketing, making derivative works, or otherwise exploiting such Our Content
        without our prior written consent.
      </p>
      <p>
        We make no endorsement, representation or warranty of any kind about Your Content or Our Content, or any information, services or
        recommendations accessed through Flux Service. We are not responsible for the accuracy, reliability, effectiveness, or correct use
        of information you receive through Flux Service.
      </p>
      <p>
        Your Content is yours. These Terms don't give us any rights to Your Content except for the limited rights that enable us to operate
        and provide Flux Service. We need your authorization to do things like hosting Your Content and backing it up. By making Your Content
        available on or through Flux Service you grant to us a non-exclusive, transferable, sub-licensable, worldwide, royalty-free,
        perpetual, irrevocable right and license to use, copy, modify, display, perform, and distribute Your Content in connection with
        operating and providing Flux Service to you. We also have the right to reformat, create derivative works of, excerpt, translate,
        modify, or otherwise change any of Your Content for storage and viewing via Flux Service. Such licenses and rights shall be
        sub-licensable by us to our affiliates and trusted third parties we work with.
      </p>
      <p>
        You represent and warrant that you own Your Content or that you have all rights necessary to Submit Your Content in the manner in
        which you choose and to grant us a license to use Your Content as described in these Terms.
      </p>
      <p>
        You warrant, represent, and agree that Your Content and the use and provision of Your Content on Flux Service as provided in these
        Terms will not: (i) infringe, misappropriate or violate a third party's patent, copyright, trademark, trade secret, or other
        intellectual property rights, or rights of publicity or privacy, or other rights; (ii) violate, or encourage any conduct that would
        violate, any applicable law, statute, regulation, or ordinance, or would give rise to civil liability; (iii) be fraudulent, false,
        misleading, deceptive, defamatory, tortuous, obscene, harmful, pornographic, vulgar, offensive, or otherwise objectionable; (iv)
        promote discrimination, racism, hatred, harassment or harm against any individual or group; (v) be violent, threatening, abusive, or
        promote violence or actions that are threatening or abusive to any person or entity; or (vi) promote illegal or harmful activities or
        substances.
      </p>
      <p>
        All comments, suggestions, feedback, or ideas Submitted by you about Flux Service are our property and we may access, copy, modify,
        redistribute, publish, or otherwise use them for any purpose and in any way without due compensation to you. We do not waive any
        right to use similar ideas previously known to us or developed by us.
      </p>

      <h2 style={sectionTitle}>12. Privacy</h2>
      <p>
        To provide Flux Service, we may collect and use your personal information. We detail our practices in our Privacy Policy, which needs
        to be read carefully before you use any Flux App related Services.
      </p>

      <h2 style={sectionTitle}>13. Changes to Flux Service</h2>
      <p>
        We may change, upgrade, discontinue, or temporarily suspend any feature or component of Flux Service at any time without notice. We
        cannot guarantee and makes no warranties that any software updates can be implemented on any devices or that changes to Flux Service
        will operate as intended. You acknowledge that you may be required to install software updates to use Flux Service, and you agree to
        promptly install such updates we provide. You are solely liable for any losses arising from a failure to timely implement such
        updates.
      </p>

      <h2 style={sectionTitle}>14. Terms of Individual Services</h2>
      <p>
        Flux Service may contain several individual services, e.g. Flux Plus Service. If you choose to use such individual services, you
        agree to further comply with the corresponding terms for such services. You may be charged for certain individual services. We also
        reserve the right to charge for certain individual services which currently is free of charge. If so, we'll notify you prior to the
        charge by sending an email to the email address associated with your account or via an in-app notification. Generally, the charge
        will be effective no less than 30 days from when we notify you.
      </p>

      <h2 style={sectionTitle}>15. Limitations of Flux Service</h2>
      <p>
        Flux Service is intended to be accessed and used for non-time-critical information. While we strive for Flux Service to be highly
        reliable and available, it is not intended to be reliable or available 100% of the time, considering that Flux Service is subject to
        sporadic interruptions and failures for a variety of reasons beyond our reasonable control, including Wi-Fi intermittency, service
        provider uptime, mobile notifications and carriers, among others. You acknowledge these limitations and agree that we are not
        responsible for any damages allegedly caused by the failure or delay of Flux Service to reflect current status of the notifications,
        or timing of Your Content.
      </p>
      <p>
        Flux Service may be suspended temporarily without notice for security reasons, system failure, maintenance and repair, updates,
        adjustments, or other circumstances. You acknowledge and agree that you will not be entitled to any refund or rebate for any such
        suspension. We do not offer any specific uptime guarantee for Flux Service. We are not liable for any losses arising from a
        suspension of Flux Service.
      </p>
      <p>
        All information concerning Flux Service is provided "as is" and "as available". We do not guarantee that this information is correct
        or up to date.
      </p>

      <h2 style={sectionTitle}>16. Limitations of Flux Service Due to Reliance on Third Parties</h2>
      <p>
        Flux Service relies on certain third party products and services. For example, we rely on mobile operating system vendors and mobile
        carriers to enable mobile device notifications through Flux Service. These third party products and services are beyond our control,
        and their operation may not operate in a reliable manner or be available 100% of the time. We are not responsible for any damages and
        losses due to the operation of these third party products and services.
      </p>
      <p>
        You acknowledge that you are responsible for all fees charged by your Internet Service Provider ("ISP") in connection with your
        access to and use of Flux Service. You also acknowledge that you are responsible for compliance with all applicable agreements, terms
        of use/service, and other policies of your ISP.
      </p>
      <p>
        You acknowledge and agree that the availability of the Flux App is dependent on the third party web services from which you download
        the Flux App – for example, the Android app market from Google or the App Store from Apple (each an "Store"). You acknowledge that
        these Terms are between you and us exclusively and not with a Store. Each Store may have its own terms and conditions to which you
        must agree before downloading Flux App from that Store. You agree to comply with, and your license to use the Flux App, is
        conditioned upon your compliance and agreement with such Store terms and conditions. To the extent such other terms and conditions
        from such Store are less restrictive than, or otherwise conflict with, the terms and conditions of these Terms, the more restrictive
        or conflicting terms and conditions in these Terms apply.
      </p>
      <p>We are not responsible for third parties or their products and services, including, without limitation, any third party products and services that enable Flux Service, ISPs, the App Stores, and Third Party Sites.</p>
      <p style={notice}>
        WE HEREBY DISCLAIM AND YOU HEREBY DISCHARGE, WAIVE AND RELEASE US AND OUR LICENSORS AND SUPPLIERS FROM ANY PAST, PRESENT, AND
        FUTURE CLAIMS, LIABILITIES, AND DAMAGES, KNOWN OR UNKNOWN, ARISING OUT OF OR RELATING TO YOUR INTERACTIONS WITH SUCH THIRD PARTIES
        AND THEIR PRODUCTS AND SERVICES.
      </p>

      <h2 style={sectionTitle}>17. Release Reading Third-Party Links</h2>
      <p>
        Flux Service may contain links to other sites, apps, software operated by third parties ("Third Party Sites"). Such Third Party Sites
        are not under our control. We provide these links and referrals only as a convenience and we do not review, approve, monitor, endorse,
        or make any representations or warranties or assume any liability with respect to such Third Party Sites for the products and services
        offered by them. We encourage you to review all applicable agreements, terms of use/service, and other policies of these Third Party
        Sites.
      </p>
      <p style={notice}>
        FLUX HEREBY DISCLAIMS AND YOU HEREBY DISCHARGE, WAIVE AND RELEASE FLUX AND ITS LICENSORS AND SUPPLIERS FROM ANY PAST, PRESENT, AND
        FUTURE CLAIMS, LIABILITIES, AND DAMAGES, KNOWN OR UNKNOWN, ARISING OUT OF OR RELATING TO YOUR INTERACTIONS WITH SUCH THIRD-PARTY
        SITES AND THEIR PRODUCTS AND SERVICES.
      </p>

      <h2 style={sectionTitle}>18. WARRANTY DISCLAIMERS</h2>
      <p style={notice}>
        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, FLUX SERVICE IS PROVIDED FOR YOUR CONVENIENCE, "AS IS", AND "AS AVAILABLE" WITH
        ALL FAULTS AND ERRORS, AND WE AND OUR SUPPLIERS AND LICENSORS EXPRESSLY DISCLAIM ANY WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER
        EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, WITHOUT LIMITATION, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY, TITLE,
        QUIET ENJOYMENT, NON-INFRINGEMENT OF THIRD-PARTY RIGHTS, AVAILABILITY, DATA SECURITY, AND ANY WARRANTIES ARISING OUT OF COURSE OF
        DEALING OR USAGE OF TRADE. Some jurisdiction does not allow the disclaimers in this paragraph, so they may not apply to you.
      </p>
      <p style={notice}>
        WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT, SOFTWARE OR SERVICE ADVERTISED OR PROVIDED BY A
        THIRD PARTY THROUGH OR IN CONNECTION WITH FLUX SERVICE OR ANY HYPERLINKED WEBSITE OR SERVICE.
      </p>
      <p style={notice}>
        WE MAKE NO REPRESENTATIONS CONCERNING ANY CONTENT CONTAINED IN OR ACCESSED THROUGH FLUX SERVICE, AND WE WILL NOT BE RESPONSIBLE OR
        LIABLE FOR THE ACCURACY, COPYRIGHT COMPLIANCE, LEGALITY OR DECENCY OF MATERIAL CONTAINED IN OR ACCESSED THROUGH FLUX SERVICE. WE
        MAKE NO REPRESENTATIONS OR WARRANTIES REGARDING SUGGESTIONS OR RECOMMENDATIONS OF SERVICES OR PRODUCTS OFFERED OR PURCHASED THROUGH
        FLUX SERVICE.
      </p>
      <p style={notice}>
        YOU ACKNOWLEDGE THAT THE USE OF FLUX SERVICE SHALL BE CONNECTED WITH THE INTERNET, AND USE SHALL BE WHOLLY AT YOUR OWN RISK. WE DO
        NOT REPRESENT OR GUARANTEE THAT FLUX SERVICE WILL BE FREE FROM LOSS, CORRUPTION, CYBER ATTACK, VIRUSES, INTERFERENCE, HACKING,
        MALWARE, OR OTHER SECURITY INTRUSION, AND WE DISCLAIM ANY LIABILITY RELATING THERETO.
      </p>
      <p style={notice}>
        AI, DATA PROTECTION, AND PRIVACY LAWS VARY BY JURISDICTION AND MAY IMPOSE CERTAIN RESPONSIBILITIES ON YOUR USE OF FLUX SERVICE. YOU
        ACKNOWLEDGE AND AGREE THAT YOU (AND NOT US) WILL BE RESPONSIBLE FOR ENSURING THAT YOU COMPLY WITH APPLICABLE LAWS WHERE YOU LIVE AND
        THAT WE SHALL NOT BE LIABLE IN THE EVENT THAT FLUX SERVICE IS USED FOR ILLEGAL PURPOSES.
      </p>

      <h2 style={sectionTitle}>19. LIMITATIONS OF LIABILITY</h2>
      <p>
        We don't exclude or limit our liability to you where it would be illegal to do so – this includes any liability for our or our
        affiliates' fraud or fraudulent misrepresentation in providing Flux Service. In jurisdiction where the following types of exclusions
        aren't allowed, we are responsible to you only for losses and damages that are a reasonably foreseeable result of our failure to use
        reasonable care and skill or our breach of our contract with you. This paragraph doesn't affect consumer rights that can't be waived
        or limited by any contract or agreement.
      </p>
      <p style={notice}>
        In jurisdiction where exclusions or limitations of liability are allowed, we, our DIRECTORS, OFFICERS, EMPLOYEES, SHAREHOLDERS,
        AFFILIATES, CONTRACTORS, AGENTS, LICENSORS, OR SUPPLIERS, SHALL NOT BE LIABLE FOR ANY INDIRECT, CONSEQUENTIAL, PUNITIVE, EXEMPLARY,
        SPECIAL, OR INCIDENTAL DAMAGES, INCLUDING ANY DAMAGES FOR LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOST DATA OR CONTENT,
        DOCUMENTATION, OR PROFITS, SERVICE INTERRUPTION, COMPUTER DAMAGE, COST OF SUBSTITUTE SERVICES, INABILITY TO USE FLUX SERVICE,
        PRIVACY LEAKAGE, OR ANY OTHER LIABILITIES OR LOSSES CAUSED BY FLUX SERVICE OR BY FAILURES OF FLUX SERVICE, WHETHER BASED ON
        WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT WE, OUR DIRECTORS, OFFICERS, EMPLOYEES, SHAREHOLDERS,
        AFFILIATES, CONTRACTORS, AGENTS, LICENSORS, OR SUPPLIERS KNEW OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES.
      </p>
      <p style={notice}>
        OTHER THAN FOR THE TYPES OF LIABILITY WE CANNOT LIMIT BY LAW (AS DESCRIBED IN THIS SECTION), WE LIMIT OUR LIABILITY TO YOU TO THE
        GREATER OF $10 USD OR 100% OF ANY AMOUNT PAID BY YOU TO US FOR FLUX SERVICE IN THE PRIOR 6 MONTHS (IF ANY) IMMEDIATELY PRECEDING
        THE DATE OF THE MOST RECENT CLAIM. THIS LIMITATION IS CUMULATIVE AND WILL NOT BE INCREASED BY THE EXISTENCE OF MORE THAN ONE
        INCIDENT OR CLAIM.
      </p>

      <h2 style={sectionTitle}>20. Indemnity</h2>
      <p>
        You agree to defend, indemnify, and hold us, our directors, officers, employees, shareholders, affiliates, contractors, agents,
        licensors, and suppliers harmless from any damages, liabilities, claims, demands, losses, or expenses, including attorneys' fees,
        made by any third party due to or arising out of or in connection with (i) your use of Flux Service which constitutes a culpable
        (negligent or willful) violation of these Terms and any other information issued by us; (ii) your culpable violation of these Terms;
        (iii) Your Content (to the extent it causes a culpable infringement), and (iv) your culpable violation of any law or the rights of
        any third party. We will use reasonable efforts to notify you of any such claim, action or proceeding without undue delay upon
        becoming aware of it.
      </p>

      <h2 style={sectionTitle}>21. Term and Termination</h2>
      <p>
        These Terms will remain in full force and effect as long as you continue to access or use Flux Service, until terminated in
        accordance with the provisions of these Terms. At any time, and without prior notice, we may suspend or terminate your rights to use
        Flux Service if we believe in good faith that you have used any Flux Service in violation of these Terms. Upon termination of your
        Account, your right to use Flux Service will automatically terminate and we may delete Your Content and other information related to
        your Account immediately, unless otherwise required by applicable laws.
      </p>

      <h2 style={sectionTitle}>22. Governing Law and Dispute Resolution</h2>
      <p>
        All matters arising out of or relating to these Terms are governed by and construed in accordance with the laws of People's Republic
        of China, without giving effect to any conflict of laws principles that may provide the application of the law of another
        jurisdiction.
      </p>
      <p>
        You agree all disputes arising out of or relating, in any way, to these Terms or your use of the Flux App, on an individual and
        purely bilateral, non-class/non-representative bases, shall be resolved by means of arbitration and shall be submitted exclusively
        to the China International Economic and Trade Arbitration Commission ("CIETAC") in Beijing in accordance with CIETAC rules. The
        preceding provision regarding dispute resolution does not apply in some jurisdiction where such dispute resolution may be prohibited.
        For example, if you are a consumer based in the European Union, you may make a claim in the courts of the country where you reside.
      </p>
      <p>
        Regardless of any statute or law to the contrary, any dispute arising out of or related to your use of Flux Service must be filed
        within one (1) year after the occurrence of the event or facts giving rise to a dispute, or you waive the right to pursue any dispute
        based upon such event or facts forever.
      </p>
      <p>
        You agree to arbitration on an individual basis. In any dispute, NEITHER YOU NOR US WILL BE ENTITLED TO JOIN OR CONSOLIDATE CLAIMS BY
        OR AGAINST OTHER CUSTOMERS IN COURT OR IN ARBITRATION OR OTHERWISE PARTICIPATE IN ANY CLAIM AS A CLASS REPRESENTATIVE, CLASS MEMBER
        OR IN A PRIVATE ATTORNEY GENERAL CAPACITY. The arbitral tribunal may not consolidate more than one person's claims, and may not
        otherwise preside over any form of a representative or class proceeding. The arbitral tribunal has no power to consider the
        enforceability of this class arbitration waiver and any challenge to the class arbitration waiver may only be raised in a court of
        competent jurisdiction.
      </p>
      <p>
        If any provision of this arbitration agreement is found unenforceable, the unenforceable provision will be severed and the remaining
        arbitration terms will be enforced.
      </p>

      <h2 style={sectionTitle}>23. Entire Agreement; Waiver; Severability</h2>
      <p>
        These Terms constitute the entire and exclusive understanding between you and us with respect to the use of Flux Service, and these
        Terms supersede and replace any and all prior oral or written understandings or agreements between you and us regarding Flux Service.
        Our failure to enforce any right or provision in these Terms will not constitute a waiver of such right or provision or of any other
        rights or provisions in these Terms. If a court or tribunal should find that one or more rights or provisions set forth in these Terms
        are invalid, you agree that the remainder of the Terms will remain in full force and effect and that the invalid provision will be
        enforceable to the fullest extent permitted by law.
      </p>

      <h2 style={sectionTitle}>24. Assignment</h2>
      <p>
        You may not assign or transfer these Terms and any associated rights or obligations, by operation of law, without our prior written
        consent. Any attempt by you to assign or transfer these Terms, without such consent, will be null and of no effect. We may freely
        assign or transfer these Terms without restriction. Subject to the foregoing, these Terms will bind and inure to the benefit of the
        parties, their successors, and permitted assigns.
      </p>

      <h2 style={sectionTitle}>25. Modifications</h2>
      <p>
        We may revise these Terms from time to time to better reflect: (i) changes to the law; (ii) new regulatory requirements, or (iii)
        improvements or enhancements made to Flux Service. If an update affects your use of Flux Service or your legal rights as a user of
        Flux Service, we'll notify you prior to the update's effective date by sending an email to the email address associated with your
        account or via an in-app notification. These updated terms will be effective no less than 7 days from when we notify you.
      </p>
      <p>
        If you don't agree to the updates we make, please do not use Flux Service before they become effective. Where applicable, we'll offer
        you a prorated refund based on the amounts you have prepaid for corresponding Flux Service and your Account closing date. By
        continuing to use or access Flux Service after the updates come into effect, you agree to be bound by the revised Terms.
      </p>

      <h2 style={sectionTitle}>26. Contact Us</h2>
      <p>
        Should you have any questions, please contact us immediately through{' '}
        <a href="mailto:appworks.ai@gmail.com" style={linkStyle}>appworks.ai@gmail.com</a>.
      </p>

      <h2 style={sectionTitle}>27. Addendum</h2>
      <h3 style={subTitle}>Privacy Policy</h3>
      <p>
        We will explain to you how we collect, use and handle your personal information when you use Flux App through Privacy Policy and
        related documents. Please review them before using the Flux App and/or related features.
      </p>
      <h3 style={subTitle}>More Information about Flux Service</h3>
      <p>
        Flux Service we offered may include (1) software applications that can be downloaded to a mobile device or computer ("Flux App"); and
        (2) any services available on Flux Apps, including Flux Plus Services and other available services.
      </p>

      <div style={{ marginTop: 40, padding: '24px 0', borderTop: '1px solid #eee', color: '#666', fontSize: 14 }}>
        <p style={{ fontWeight: 600 }}>Hangzhou Furui Technology Co., Ltd.</p>
        <p>Floor 2, Building B, No.630, Qizhi Street, Binjiang District, Hangzhou City, Zhejiang Province, China.</p>
      </div>

      <div style={{ height: 60 }} />
    </div>
  )
}

const container = { maxWidth: 800, margin: '0 auto', padding: '40px 20px', fontFamily: 'system-ui, -apple-system, sans-serif', color: '#333', lineHeight: 1.8 }
const sectionTitle = { fontSize: 20, fontWeight: 700, marginTop: 40, marginBottom: 12, color: '#111' }
const subTitle = { fontSize: 16, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#222' }
const listStyle = { paddingLeft: 24, marginBottom: 16 }
const linkStyle = { color: '#7c3aed', textDecoration: 'underline' }
const notice = { fontWeight: 600, marginBottom: 16 }

export default TOSLicense
